import { Button, Modal, ModalBody, Badge, Row, Col } from 'reactstrap';

export type StatusLegendModalProps = {
    isOpen: boolean;
    toggle: () => void;
};

export const StatusLegendModal = (props: StatusLegendModalProps) => {
    const { isOpen, toggle } = props;

    return (
        <Modal centered size='lg' isOpen={isOpen} toggle={toggle}>
            <ModalBody>
                <h3>What do these statuses mean?</h3>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-draft'>
                            Draft
                        </Badge>
                    </Col>
                    <Col>
                        The fund request has been started but not yet submitted
                        to Help Hope Live
                    </Col>
                </Row>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-submitted'>
                            Submitted
                        </Badge>
                    </Col>
                    <Col>
                        The fund request has been submitted to Help Hope Live
                        for review and cannot be edited
                    </Col>
                </Row>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-in_review'>
                            In Review
                        </Badge>
                    </Col>
                    <Col>
                        The fund request is currently in review by Help Hope
                        Live and cannot be edited
                    </Col>
                </Row>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-needs_info'>
                            Needs Info
                        </Badge>
                    </Col>
                    <Col>
                        Help Hope Live has reviewed the fund request and has
                        noted that additional information is needed to approve
                        it
                    </Col>
                </Row>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-resubmitted'>
                            Resubmitted
                        </Badge>
                    </Col>
                    <Col>
                        The fund request has been resubmitted after needing
                        additional information
                    </Col>
                </Row>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-approved'>
                            Approved
                        </Badge>
                    </Col>
                    <Col>
                        The fund request has been approved for payment and is
                        waiting to be paid
                    </Col>
                </Row>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-paid'>
                            Paid
                        </Badge>
                    </Col>
                    <Col>The fund request has been paid</Col>
                </Row>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-rejected'>
                            Rejected
                        </Badge>
                    </Col>
                    <Col>
                        The fund request has been rejected, in some cases you
                        may be able to appeal the decision
                    </Col>
                </Row>
                <Row className='my-3'>
                    <Col xs={4} sm={3} lg={2}>
                        <Badge color='none' className='badge-pending'>
                            Pending
                        </Badge>
                    </Col>
                    <Col>
                        The fund request has been created as a remainder from a
                        partial disbursement of a previous fund request
                    </Col>
                </Row>

                <Button color='outline-dark' onClick={toggle}>
                    Close
                </Button>
            </ModalBody>
        </Modal>
    );
};
